import { getCurrentInstance } from "vue";

export function useContentSubpageInstance() {
  const { proxy } = getCurrentInstance()!;
  return proxy?.$contentSubpage;
}
